<template>
  <div v-if="!disabled">
    <transition name="fade" appear>
      <div class="div-navbar">
        <div class="nav-left">
          <ChevronLeft v-if="!notChevronLeft.includes(currentRoute) && !disabled" class="icon-home" @click="goBack" :size="40" style="margin-left: 10px;" />
          <span v-else style="margin-left: 15px;" />
          <div v-if="!disabledMenu" class="hamburger-menu" @click="toggleNav" style="margin-left: 10px;">
            <div class="hamburger-menu__icon bar-1"></div>
            <div class="hamburger-menu__icon bar-2"></div>
            <div class="hamburger-menu__icon bar-3"></div>
          </div>
        </div>
        <div v-if="logo && logo.url" class="logo-container">
          <img :src="logo.url" alt="logo" class="icon-logo" />
        </div>
      </div>
    </transition>
    <transition name="pop" appear>
      <div v-if="showModal" class="sidenav">
        <div class="div-flex-between">
          <img @click="goHome" :src="logo.url" alt="logo" class="icon-logo" />
          <span @click="toggleNav" class="closebtn">&times;</span>
        </div>
        <template v-if="listaItens.length > 0" >
          <Menu
            :itensMenu="listaItens"
            :inicio="inicio"
            @itemselecionado="selecaomenu"
            @retornar="retornomenu"
          />        
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import FirebaseHelper from "../service/FirebaseHelper";
import Menu from "./Menu.vue";
import ChevronLeft from "vue-material-design-icons/ChevronLeft.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "NavBar",
  components: { ChevronLeft, Menu },
  data() {
    return {
      disabled: false,
      inicio: true,
      firebaseHelper: new FirebaseHelper(),
      showModal: false,
      listaInicial: [],
      listaItens: [],
      logo: this.imagens.find((img) => img.nome === "logo_colorida_192x192"),
      backRoutes: [
        "/resgatesolicitado",
        "/vitrineparceiros",
        "/simuladorbeneficiofinalizado",
        "/contratacao",
        "/login"
      ],
      notChevronLeft: [
        "/", 
        "/trocaparticipacao"
      ]
    };
  },
  computed: {
    ...mapGetters({
      participante: "participante",
      login: "login",
      chave: "chave",
      cpf: "cpf",
      plano: "plano",
      isRP: "isRP"
    }),
    currentRoute() {
      return this.$route.path;
    },  
    listaItens(){
      return this.listaItens
    }
  },
  mounted() {
    this.emitter.on("disabled_navbar", (value) => {
      this.disabled = value || false;
    });
    this.emitter.on("atualizaNavbar", (plano) => {
      this.carregarMenuSistema(plano);
    });
    this.emitter.on("navbar_error", () => {
      this.disabled = false
      this.carregarMenuError()
    })
  },
  watch: {    
    showModal(val) {
      if (!val) {
        this.resetMenu();
      }
    },
  },
  methods: {
    ...mapActions([
      "atualizarEstadoParticipante",
      "atualizarEstadoLogin",
      "atualizarEstadoChave",
      "atualizarEstadoCpf",
      "atualizarEstadoListaChaves"
    ]),
    carregarMenuError() {
      this.listaInicial = []
      this.listaInicial.push({
        id: 8,
        origem: 0,
        textoprincipal: "Sair do App",
        textosecundario: "",
        view: "/logout",
        subitem: "",
        visivel: ['Novo', 'Assistido', 'Antigo','error']
      });
      this.listaItens = this.listaInicial
    },
    async carregarMenuSistema(plano) {
      this.listaInicial = await this.firebaseHelper.getMenuSistema(plano);      
      this.listaItens = this.listaInicial
      //this.updateVisibility();
    },    
    updateVisibility() {
      const isEmpréstimoVigente = this.participante?.projetoVida?.emprestimo?.vigente;
      this.listaItens.forEach(menu => {
        if (menu.id === 3) {
          menu.visivel = isEmpréstimoVigente ? ["Antigo"] : [""];
        }
      });
    },
    resetMenu() {
      this.listaItens = this.listaInicial;
      this.inicio = true;
    },
    goBack() {
      if(this.isRP && this.currentRoute === "/cadastroincompleto") {
        this.$router.push("/trocaparticipacao")
      } else {      
        this.backRoutes.includes(this.currentRoute) ? this.$router.push("/") : this.$router.back();
      }
    },
    goHome() {
      this.showModal = false;
      this.$router.push("/");
      this.toggleHamburgerAnimation();
    },
    retornomenu(item) {
      if (item.origem === 0) this.resetMenu();
    },
    async selecaomenu(item) {
      if (item.view) {
        this.showModal = false;
        this.toggleHamburgerAnimation();
        if (item.view === "/logout") {
          await this.firebaseHelper.signOut(this.auth);
          if (!this.auth.currentUser) this.resetStateAndRedirect();
        } else {
          this.$router.push(item.view);
        }
      } else {
        this.listaItens = item.subitem;
        this.inicio = false;
      }
    },
    resetStateAndRedirect() {
      this.atualizarEstadoParticipante({});
      this.atualizarEstadoLogin({});
      this.atualizarEstadoChave('');
      this.atualizarEstadoCpf('');
      this.atualizarEstadoListaChaves({});
      this.$router.push("/login");
    },
    toggleNav() {
      this.showModal = !this.showModal;
      this.toggleHamburgerAnimation();
    },
    toggleHamburgerAnimation() {
      const hamburguerMenu = document.getElementsByClassName("hamburger-menu")[0];
      hamburguerMenu.classList.toggle("change");
    },
  },
};
</script>

<style scoped>

.icon-home {  
  cursor: pointer;  
  color: #317abb;
}

.icon-logo {
  height: 50px;
}

.div-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0px;
}

.nav-left {
  display: flex;
  align-items: center;
}

.back-button {
  margin-right: 10px;
}
.sidenav li.closebtn {
  border: none;
}

.sidenav .closebtn {
  right: 25px;
  color: #317ABB;
  text-align: right;
  font-size: 50px;
}

.hamburger-menu {
  display: inline-block;
  cursor: pointer;
}

.div-flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    margin: 20px;
  }

.hamburger-menu__icon {
  width: 24px;
  height: 3px;
  margin: 6px 0;
  background-color: #317abb;
  transition: 0.4s;
}

.change .bar-1 {
  transform: rotate(-45deg) translate(-5px, 4px);
}

.change .bar-2 {
  opacity: 0;
}

.change .bar-3 {
  transform: rotate(45deg) translate(-8px, -8px);
}

.sidenav li a {
  padding: 8px 8px 8px 32px;
  display: block;
  text-decoration: none;
  font-family: 'MaisFuturo-Thin';
  font-size: 16px;
  color: #f1f1f1;
  transition: 0.3s;
}

.sidenav {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 7;
  top: 0;
  left: 0;
  background-color: white;
  transition: 0.5s;
}

.fade-enter-active,.fade-leave-active {
  transition: opacity .4s linear;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}

.pop-enter,
.pop-leave-to {
  opacity: 0;
  transform: scale(0.3) translateY(-110%);
}

</style>
